import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'red' | 'white';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'red',
  href = '#offer'
}: CTAButtonProps) {
  const colors = variant === 'red' ? 'bg-brand-red text-white hover:bg-[#c72c39] focus-visible:ring-brand-red' : 'bg-white text-brand-blue hover:bg-brand-main focus-visible:ring-white';
  return <a href={href} className={`cta-attention inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold tracking-wide shadow-md transition-[background-color,box-shadow] duration-200 ease-out hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-57" data-mp="2p0t6trcd73pd">
      {children}
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="38oiq1a68jvmz" />
    </a>;
}